var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0041 11.0171C13.4549 11.0171 15.4417 9.0303 15.4417 6.57945C15.4417 4.12859 13.4549 2.14178 11.0041 2.14178C8.55322 2.14178 6.56641 4.12859 6.56641 6.57945C6.56641 9.0303 8.55322 11.0171 11.0041 11.0171Z",
    stroke: "white",
    strokeWidth: 1.3313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38086 19.8924C3.38086 16.4577 6.79786 13.6797 11.0048 13.6797C11.8568 13.6797 12.6822 13.7951 13.4544 14.0081",
    stroke: "white",
    strokeWidth: 1.3313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8796 16.3423C19.8796 16.6263 19.8441 16.9014 19.7731 17.1677C19.6932 17.5227 19.5512 17.8689 19.3648 18.1706C18.7524 19.2002 17.6252 19.8924 16.3294 19.8924C15.4153 19.8924 14.5899 19.5463 13.9686 18.9783C13.7023 18.7475 13.4716 18.4724 13.2941 18.1706C12.9657 17.6381 12.7793 17.008 12.7793 16.3423C12.7793 15.3838 13.1609 14.5051 13.7822 13.8661C14.4301 13.2005 15.3354 12.7922 16.3294 12.7922C17.3767 12.7922 18.3264 13.2448 18.9654 13.9726C19.5334 14.6028 19.8796 15.437 19.8796 16.3423Z",
    stroke: "white",
    strokeWidth: 1.3313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6526 16.3246H15.0078",
    stroke: "white",
    strokeWidth: 1.3313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3301 15.0288V17.6825",
    stroke: "white",
    strokeWidth: 1.3313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.71205a9c6e17823d760e919086790dcb.svg";
export { ForwardRef as ReactComponent };